/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Styles from './Renegociacao25Emprestimos.css';
import Renegociacao25Canais from '@/components/organisms/Renegociacao25Canais';
import Renegociacao25EmpNegocie from '@/components/organisms/Renegociacao25EmpNegocie';
import Renegociacao25EmpVantagens from '@/components/organisms/Renegociacao25EmpVantagens';
import Renegociacao25EmpConfira from '@/components/organisms/Renegociacao25EmpConfira';
import Renegociacao25EmpDDA from '@/components/organisms/Renegociacao25EmpDDA';
import Renegociacao25EmpCanais from '@/components/organisms/Renegociacao25EmpCanais';

function Renegociacao25Emprestimos({ show }) {
  return (
    <>
      <div id="page-renegociacao-emprestimos" className={show ? 'show' : ''}>
        <Renegociacao25EmpNegocie />
        <Renegociacao25EmpVantagens />
        <Renegociacao25EmpConfira />
        <Renegociacao25EmpDDA />
        <Renegociacao25EmpCanais />
        <style jsx>{Styles}</style>
      </div>
    </>
  );
}

export default Renegociacao25Emprestimos;
